import { render, staticRenderFns } from "./MaasUzerindekiHacizlerinKaldirilmasiTalepEvrakForm.vue?vue&type=template&id=01bdaa4c"
import script from "./MaasUzerindekiHacizlerinKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./MaasUzerindekiHacizlerinKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports